import { FilterConfigPassive } from '@/types/filter';

const insightIndicationFilter: FilterConfigPassive = {
  label: 'main.insights.filters.labels.taIndication',
  placeholder: 'main.insights.filters.labels.taIndication',
  type: 'multiselect',
  defaultValue: [],
  disabled: true,
  options: [],
  useFloatingLabel: true,
  searchable: true,
  clearable: true,
};

export default insightIndicationFilter;
